import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CollectionProjectSharedTimelineComponent } from "../../base/timeline/collection-project-shared-timeline.component";
import { FeatureFlagsService } from "../../../../services/internal-services/feature-flags.service";
import { MapService } from "../../../../services/internal-services/map.service";
import { GoogleAnalyticsService } from "../../../../../shared/services/google-analytics.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-projects-timeline",
  templateUrl: "../projects-timeline.component.html",
  styleUrls: ["../../base/timeline/base-timeline.component.scss"],
  standalone: false,
})
export class ProjectTimelineComponent extends CollectionProjectSharedTimelineComponent {
  constructor(
    googleAnalyticsService: GoogleAnalyticsService,
    cdr: ChangeDetectorRef,
    flagService: FeatureFlagsService,
    mapService: MapService,
  ) {
    super(googleAnalyticsService, cdr, flagService, mapService);
  }
}
